import {
  ChangeDetectionStrategy,
  Component,
  ViewEncapsulation,
} from '@angular/core';
import { AgRendererComponent } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { TcGridEventButtonParams } from '../../interfaces/tc-grid.interface';

/**
 * This is all in one combination of:
 * @TcGridButtonsRendererComponent
 * @TcGridFaButtonsRendererComponent
 * @TcButtonsListComponent
 *
 * Handles the diplay of dumb buttons for @TcGrid
 */
@Component({
  selector: 'tc-grid-event-buttons-renderer.component',
  templateUrl: './tc-grid-event-buttons-renderer.component.html',
  styleUrls: ['./tc-grid-event-buttons-renderer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class TcGridEventButtonsRendererComponent
  implements AgRendererComponent
{
  /**
   * Params specified in the cellRendererParams of the ag-grid column definition
   */
  public params: ICellRendererParams;

  /**
   * Buttons Configuraions from @params
   */
  public buttons: TcGridEventButtonParams[];

  /**
   * Stores the disable states of the buttons
   */
  public disableButtons: boolean[] = [];

  /**
   * Stores the hidden states of the buttons
   */
  public hiddenButtons: boolean[] = [];

  agInit(params) {
    this.params = params;
    this.buttons = params?.buttons;

    this.checkDisabledButtons();
    this.checkHiddenButtons();
  }

  /**
   * Handles the click event by triggering the button action
   * @param event => { clickEvent (native click event), buttonIndex }
   */
  public onClickHandler(event) {
    const { clickEvent, index } = event;

    this.buttons[index]?.action(this.params?.node?.data);
  }

  /**
   * Determine which buttons should be dissabled
   */
  private checkDisabledButtons() {
    this.buttons.forEach((button) => {
      this.disableButtons.push(this.isDisabled(button));
    });
  }

  /**
   * Helper function for @checkDisabledButtons
   */
  private isDisabled(button: TcGridEventButtonParams) {
    if (!button.disabled) {
      return false;
    }

    const isDisabled = button.disabled(this.params?.node?.data);
    return !!isDisabled;
  }

  /**
   * Determine which buttons should be hidden
   */
  private checkHiddenButtons() {
    this.buttons.forEach((button) => {
      this.hiddenButtons.push(this.isHidden(button));
    });
  }

  /**
   * Helper function for @checkHiddenButtons
   */
  private isHidden(button: TcGridEventButtonParams) {
    if (!button.hidden) {
      return false;
    }

    const isHidden = button.hidden(this.params?.node?.data);
    return !!isHidden;
  }

  refresh(params: ICellRendererParams) {
    return false;
  }
}
